/**
 * 
 */


document.addEventListener('DOMContentLoaded', function() {

    General_init.init();

    init_2();

    init_3();

}, false);






var verifObj;

function init_2() {

    var xhr = new XMLHttpRequest();

    xhr.addEventListener('load', function() {

        var text = xhr.responseText;

        verifObj = JSON.parse(text);

        var nowtimes = verifObj.verifNowTimes;


        var def3Arr = verifObj.defBase3;
        var def4Arr = verifObj.defBase4;
        var high3Arr = verifObj.highBase3;
        var high4Arr = verifObj.highBase4;

    
        //
        if(def3Arr) {   nowTableMake( 3, "", def3Arr[0]);   };
        if(def4Arr) {   nowTableMake( 4, "", def4Arr[0]);   };
        if(high3Arr) {  nowTableMake( 3, "high-", high3Arr[0]);  };
        if(high4Arr) {  nowTableMake( 4, "high-", high4Arr[0]);  };

        latestTableMake(3, "", def3Arr);
        latestTableMake(4, "", def4Arr);
        latestTableMake(3, "high-", high3Arr);
        latestTableMake(4, "high-", high4Arr);


    }, false);

    xhr.addEventListener('error', function() {
        
        //alert(' データへのアクセスができませんでした。');
        console.log( 'init2() Http エラー' );

    }, false);
    
    xhr.open('GET', '../data/nbVerifPool.dat', true);
    xhr.send(null);

};


function nowTableMake(or34, label, nowVerifBean) {

    if(nowVerifBean) {
        var div = document.getElementById('nowTableDiv-'+label+or34);
        var table = document.createElement( 'table' );
        table.border = 1;
    
        var cap = document.createElement('caption');
        cap.appendChild(document.createTextNode('ナンバーズ'+or34));
        table.appendChild(cap);
    
        var colg = document.createElement('colgroup');
        colg.span = 1;
        colg.id = 'colg-1';
        table.appendChild(colg);
    
        tableAdd( nowVerifBean, div, table );
    };
};


function latestTableMake(or34, label, verifBeanList) {

    if(verifBeanList) {
        var div = document.getElementById('latestTableDiv-'+label+or34);
        for(var i=1, n=verifBeanList.length; i<n; i++) {
            var verifBean = verifBeanList[i];
    
            var table = document.createElement( 'table' );
            table.border = 1;
        
            var colg = document.createElement('colgroup');
            colg.span = 1;
            colg.id = 'colg-1';
            table.appendChild(colg);
        
            tableAdd( verifBean, div, table );
        };
    };
};






function tdAdd( tr, valArr ) {

    for(var val of valArr) {

        var td = document.createElement( 'td' );
        var ndB = document.createElement( 'b' );

        ndB.appendChild( document.createTextNode( val ) );
        td.appendChild( ndB );
        tr.appendChild( td );
    };
};
function trTdAdd( tr, label, colspan_size ) {
    var td = document.createElement( 'td' );
    if(colspan_size!=null && colspan_size!=0) {   td.colSpan = colspan_size;   };
    var ndB = document.createElement( 'b' );
    ndB.appendChild( document.createTextNode( label ) );
    td.appendChild( ndB );
    tr.appendChild(td);
};
function tdTextAdd( td, valArr ) {
    var val = '';
    var ndB = document.createElement( 'b' );
    for(var i=0, n=valArr.length; i<n; i++) {    
        var va = valArr[i];
        val += va;
        if(i<n-1) {
            val += '、'
        };
    };
    ndB.appendChild( document.createTextNode( val ) );
    td.appendChild( ndB );
};
function trTdArrAdd( tr, valArr ) {

    for(var i=0, n=valArr.length; i<n; i++) {
        var td = document.createElement( 'td' );
        var ndB = document.createElement( 'b' );
        var val = valArr[i];
        ndB.appendChild( document.createTextNode( val ) );
        td.appendChild( ndB );
        tr.appendChild(td);
    };
};



function tableAdd( verifBean, div, table ) {

    var trTh = document.createElement( 'tr' );
    var th = document.createElement( 'th' );
    var nbB = document.createElement( 'b' );
    nbB.appendChild( document.createTextNode( verifBean.times+'回' ) );
    th.appendChild( nbB );
    th.colSpan = 5;
    trTh.appendChild( th );
    table.appendChild( trTh );

    if(verifBean.filter) {
        var trTdFilter = document.createElement( 'tr' );
        var tdFilterLavel = document.createElement( 'td' );
        var nbB = document.createElement( 'b' );
        nbB.appendChild( document.createTextNode( 'フィルター' ) );
        tdFilterLavel.appendChild( nbB );
        trTdFilter.appendChild( tdFilterLavel );
        var tdFilterVal = document.createElement( 'td' );  tdFilterVal.colSpan = 4;
        tdTextAdd( tdFilterVal, verifBean.filter );
        trTdFilter.appendChild( tdFilterVal );
        table.appendChild( trTdFilter );
    };

    var trTdHaniMin = document.createElement( 'tr' );
    trTdAdd( trTdHaniMin, '最小％' );
    trTdAdd( trTdHaniMin, verifBean.minPercent+'%', 4 );
    table.appendChild( trTdHaniMin );

    var trTdHaniMax = document.createElement( 'tr' );
    trTdAdd( trTdHaniMax, '最大％' );
    trTdAdd( trTdHaniMax, verifBean.maxPercent+'%', 4 );
    table.appendChild( trTdHaniMax );


    var trTdHani = document.createElement( 'tr' );
    trTdHani.style.background = "#f5f5ff";
    trTdAdd( trTdHani, '  ' );
    var haniLabel = [   '全体','50%台','6-70%台','80%以上'   ];
    trTdArrAdd( trTdHani, haniLabel );
    table.appendChild( trTdHani );

    var trTdSize = document.createElement( 'tr' );
    trTdAdd( trTdSize, '個数' );
    var size = [verifBean.size];
    size.push(verifBean.size59[0], verifBean.size59[1]+verifBean.size59[2], verifBean.size59[3]);
    trTdArrAdd( trTdSize, size );
    table.appendChild( trTdSize );

    var trTdTheory = document.createElement( 'tr' );
    trTdAdd( trTdTheory, '理論値' );
    var thCt = [verifBean.thCt];
    thCt.push(verifBean.thCt59[0], Math.round( (verifBean.thCt59[1]+verifBean.thCt59[2])*100 )/100.0, verifBean.thCt59[3]);
    trTdArrAdd( trTdTheory, thCt );
    table.appendChild( trTdTheory );

    if(verifBean.count !== 0) {
        var trTdCount = document.createElement( 'tr' );
        trTdAdd( trTdCount, '実際値' );
        var count = [verifBean.count];
        count.push(verifBean.count59[0], verifBean.count59[1]+verifBean.count59[2], verifBean.count59[3]);
        trTdArrAdd( trTdCount, count );
        table.appendChild( trTdCount );
    
        var trTdRate = document.createElement( 'tr' );
        trTdAdd( trTdRate, '比率' );
        var rate = [verifBean.rate];
        var rate67 = Math.round( count[2]/thCt[2]*100 )/100.0;
        rate.push(verifBean.rate59[0], rate67, verifBean.rate59[3]);
        trTdArrAdd( trTdRate, rate );
        table.appendChild( trTdRate );
    
    };

    div.appendChild( table );
    
};



function init_3() {

    document.getElementById('change34-bt').addEventListener('click', or34ChangeDiv( stateObj ), false);
    document.getElementById('changeType-bt').addEventListener('click', typeChangeDiv( stateObj ), false);
};


let stateObj = { index: 0 };
const lateArr = [ 'latestTableDiv-3', 'latestTableDiv-4', 'latestTableDiv-high-3', 'latestTableDiv-high-4' ];


function or34ChangeDiv( isStateObj ) {
    let obj = isStateObj;
    return function() {
        let val = obj.index;
        obj.index = (Math.floor(val/2)*2)+((val+1)%2);

        lateChengeSub( obj.index );
    };
};

function lateChengeSub(val) {

    if(val%2===0) {
        document.getElementById('nb3Img').style['display'] = 'inline';
        document.getElementById('nb4Img').style['display'] = 'none';
    }else {
        document.getElementById('nb3Img').style['display'] = 'none';
        document.getElementById('nb4Img').style['display'] = 'inline';
    };
    for(let i=0, n=lateArr.length; i<n; i++) {

        document.getElementById(lateArr[i]).style['display'] = i===val ? 'block' : 'none';
    };
};


function typeChangeDiv( isStateObj ) {

    let obj = isStateObj;
    return function() {
        let val = obj.index;
        obj.index = (val+2)%4;

        lateChengeSub( obj.index );
    };
};





